import React from 'react';
import { MediaKitHighlight } from '../services/mediaKitService';

interface MediaKitHighlightCardsProps {
    highlights: MediaKitHighlight[];
}

function HighlightArrow() {
    return (
        <span className="media-kit-highlight-arrow" aria-hidden="true">
            ↓
        </span>
    );
}

function HighlightCard({ highlight }: { highlight: MediaKitHighlight }) {
    const title = highlight.title?.trim();
    const description = highlight.description?.trim();
    const impact = highlight.impact?.trim();

    if (!title && !description && !impact) {
        return null;
    }

    return (
        <div className="media-kit-highlight-card">
            {title && <h4 className="media-kit-highlight-title">{title}</h4>}
            {title && (description || impact) && <HighlightArrow />}
            {description && <p className="media-kit-highlight-description">{description}</p>}
            {description && impact && <HighlightArrow />}
            {impact && <p className="media-kit-highlight-impact">{impact}</p>}
        </div>
    );
}

export default function MediaKitHighlightCards({ highlights }: MediaKitHighlightCardsProps) {
    const visibleHighlights = highlights.filter(
        (h) => h.title?.trim() || h.description?.trim() || h.impact?.trim(),
    );

    if (visibleHighlights.length === 0) {
        return null;
    }

    return (
        <div className="media-kit-highlights-grid">
            {visibleHighlights.map((highlight) => (
                <HighlightCard key={highlight.id} highlight={highlight} />
            ))}
        </div>
    );
}
